import React from 'react'

type IconProps = {
  width?: number
  height?: number
}

const FlagSquareDenmark: React.FunctionComponent<IconProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.66667 5.66666H22.3333V18.3333H1.66667V5.66666Z" fill="#D22F27" />
    <path
      d="M22.3333 11H10V5.66666H8V11H1.66667V13H8V18.3333H10V13H22.3333V11Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
  </svg>
)

const FlagSquareGermany: React.FunctionComponent<IconProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.66666 5.66666H22.3333V18.3333H1.66666V5.66666Z" fill="#F1B31C" />
    <path d="M1.66666 10H22.3333V14H1.66666V10Z" fill="#D22F27" />
    <path d="M1.66666 5.66666H22.3333V9.99999H1.66666V5.66666Z" fill="black" />
  </svg>
)
const FlagSquareNorway: React.FunctionComponent<IconProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.66667 5.66666H22.3333V18.3333H1.66667V5.66666Z" fill="#D22F27" />
    <path d="M22.3333 11H10V5.66666H8V11H1.66667V12V13H8V18.3333H9H10V13H22.3333V11Z" fill="#1E50A0" />
    <path
      d="M22.3333 11H10V5.66666M8 5.66666V11H1.66667M1.66667 13H8V18.3333M10 18.3333V13H22.3333"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
  </svg>
)

const FlagSquareUK: React.FunctionComponent<IconProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.66666 5.66666H22.3333V18.3333H1.66666V5.66666Z" fill="#1E50A0" />
    <path d="M13.3333 9.61866V10.6667H16.727L22.3333 7.23032V5.66666H19.782L13.3333 9.61866Z" fill="white" />
    <path d="M22.3333 5.66666H21.0577L13.3333 10.401V10.6667H14.494L22.3333 5.86199V5.66666Z" fill="#D22F27" />
    <path d="M19.7823 18.3333H22.3333V16.7693L16.7273 13.3333H13.3333V14.381L19.7823 18.3333Z" fill="white" />
    <path d="M22.3333 18.3333V17.551L15.4517 13.3333H13.856L22.014 18.3333H22.3333Z" fill="#D22F27" />
    <path d="M10.6667 14.3813V13.3333H7.273L1.66666 16.7697V18.3333H4.218L10.6667 14.3813Z" fill="white" />
    <path d="M1.66666 18.3333H2.94233L10.6667 13.599V13.3333H9.506L1.66666 18.138V18.3333Z" fill="#D22F27" />
    <path d="M4.21766 5.66666H1.66666V7.23066L7.27266 10.6667H10.6667V9.61899L4.21766 5.66666Z" fill="white" />
    <path d="M1.66666 5.66666V6.44899L8.54866 10.6667H10.144L1.986 5.66666H1.66666Z" fill="#D22F27" />
    <path d="M1.66666 10.3333H22.3333V13.6667H1.66666V10.3333Z" fill="white" />
    <path d="M10.3333 5.66666H13.6667V18.3333H10.3333V5.66666Z" fill="white" />
    <path d="M1.66666 11H22.3333V13H1.66666V11Z" fill="#D22F27" />
    <path d="M11 5.66666H13V18.3333H11V5.66666Z" fill="#D22F27" />
  </svg>
)

export { FlagSquareDenmark, FlagSquareGermany, FlagSquareNorway, FlagSquareUK }
